import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CRouteList } from '@app/route-list.const';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {
  private readonly cRoutes = CRouteList;
  currentTitle = '';
  constructor(
    private title: Title,
    private translateService: TranslateService,
    private liveAnnouncer: LiveAnnouncer,
    private analyticsService: AnalyticsService
  ) {}

  /**
   * Sets the page Title
   * @param venueName The name of the venue
   * @param routeName the uppercase friendly name of the current page.
   */
  setTitle(venueName: string | undefined, routeName: string | undefined, url?: string): void {
    venueName = venueName ? venueName + ' ' : '';
    if (!routeName) {
      routeName = 'UNKNOWN';
    }

    const page = this.translateService.instant(`GENERIC.ROUTES.${routeName}`);
    const fullTitle = this.translateService.instant('GENERIC.ONLINE_TICKETS', {
      venueName,
      page
    });
    if (this.currentTitle !== fullTitle) {
      this.title.setTitle(fullTitle);
      void this.liveAnnouncer.announce(fullTitle);
      this.currentTitle = fullTitle;
      this.analyticsService.onPageView(this.currentTitle, page, url || '');
    }
  }

  /** Action to announce for screen reader the page title. */
  announceTitle(): void {
    void this.liveAnnouncer.announce(this.title.getTitle());
  }

  /**
   * Gets the page title.
   * @return the current page title
   */
  getTitle(): string {
    return this.title.getTitle();
  }
}
